import React, {Component} from 'react';
import axios from "axios";
import UserLogin from './login/UserLogin';
import UserRegister from './login/UserRegister';
import {toast} from "react-toastify";
import UserRegisterBracBank from './login/UserRegisterBracBank';
import UserLoginBracBank from './login/UserLoginBracBank';

class BracBankRequiredLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogin: this.props.isLogin,
            email: '',
            otpcode: '',
            confirm_password: '',
            password: '',
        }
        
        this.key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
    }

    UserLogout = (value) => {
        this.props.onClick('false', '');
        this.setState({isLogin: 'false'});
        localStorage.isLogin = 'false';
        localStorage.token = '';
        localStorage.userName = '';
    }

    handleChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: value
        });
    }

    forgetPassSubmit = (event) => {
        const key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
        const url = `${localStorage.apiHost}/forget-password`;
        let data = JSON.stringify({
            'email': this.state.email,
            'program-id': localStorage.programId,
        });
        axios({
            method: 'post',
            url: url,
            data: data,
            headers: {
                'key': key,
                "Content-Type" : "application/json"
            }

        }).then(response => {

            console.log(response.data);

            if (response.data.status === 200) {

                localStorage.token = response.headers.token;
                toast.success(response.data.message);
                
                let forget = document.getElementById('forgetClose');
                
                document.getElementById('matchOtpModalBtn').click();
                
                if(forget){forget.click()}

                

            }else{
                toast.error(response.data.message);
                localStorage.token = '';
            }
        });
        event.preventDefault();
    }

    resendVerificationCode = (event) => {
        const key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
        const url = `${localStorage.apiHost}/resend-otp-code`;
        let data = JSON.stringify({
            'email': this.state.email,
            'program-id': localStorage.programId,
        });
        axios({
            method: 'post',
            url: url,
            data: data,
            headers: {
                'key': key,
                "Content-Type" : "application/json"
            }

        }).then(response => {

            console.log(response.data);

            if (response.data.status === 200) {
                
                toast.success(response.data.message);

            }else{

                toast.error(response.data.message);

            }

        });

        event.preventDefault();
    }

    VerificationCodeSubmit = (event) => {
        const key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
        const url = `${localStorage.apiHost}/check-otp-code`;
        let data = JSON.stringify({
            'otp-code': this.state.otpcode,
            'program-id': localStorage.programId,
        });
        axios({
            method: 'post',
            url: url,
            data: data,
            headers: {
                'key': key,
                'access-token': localStorage.token,
                "Content-Type" : "application/json"
            }

        }).then(response => {

            if (response.data.status === 200) {

                toast.success(response.data.message);
                
                let ver = document.getElementById('verificationClose');
                
                if(ver){ver.click()}
                
                document.getElementById('resetPassModalBtn').click();

            }else{
                toast.error(response.data.message);
            }
        });
        event.preventDefault();
    }

    resetPassword = (event) => {

        const key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
        const url = `${localStorage.apiHost}/reset-password`;
        let data = JSON.stringify({
            'password': this.state.password,
            'confirm-password': this.state.confirm_password,
            'program-id': localStorage.programId,
        });
        axios({
            method: 'post',
            url: url,
            data: data,
            headers: {
                'key': key,
                'access-token': localStorage.token,
                "Content-Type" : "application/json"
            }

        }).then(response => {

            console.log(response.data);

            if (response.data.status === 200) {

                toast.success(response.data.message);
                
                let reset = document.getElementById('resetClose');
                
                if(reset){reset.click()}

            }else{

                toast.error(response.data.message);

            }
        });
        event.preventDefault();
    }

    render() {
        return (
            <>
            {localStorage.programId != 'fe150217-61af-4e2a-8a84-68feb2d66cde' &&
            <div className="col-md-12 no-sm-h-padding mt-2 mb-3">
                <div className="col-md-12 viewer-section" style={{background: localStorage.navigationBarBgColor}}>
                    <div className="row mb-2 pt-2 pb-2">         
                        <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4 col-sm-12 col-xs-12">
                            <br></br>
                            <br></br>
                            <h4 className='text-center'>Login</h4>
                            <hr></hr>
                            <br></br>
                            <UserLoginBracBank onClick={this.props.onClick}/>
                            <br></br>
                            <br></br>
                        </div> 
                        <div className="col-md-12 col-sm-12 col-xs-12 mt-auto mb-auto">
                            
                            <div className="modal fade" id="login">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                    
                                        {/* <!-- Modal Header --> */}
                                        <div className="modal-header">
                                            <h5>Login</h5>
                                            <button type="button" id="loginClose" className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        
                                        {/* <!-- Modal body --> */}
                                        <div className="modal-body">
                                            <UserLoginBracBank onClick={this.props.onClick}/>                                                        
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="register">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                    
                                        {/* <!-- Modal Header --> */}
                                        <div className="modal-header">
                                            <h5>Registration</h5>
                                            <button type="button" id="registerClose" className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        
                                        {/* <!-- Modal body --> */}
                                        <div className="modal-body">
                                            <UserRegisterBracBank onClick={this.props.onClick}/>                                                        
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="forgetPassModal">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                    
                                        {/* <!-- Modal Header --> */}
                                        <div className="modal-header">
                                            <h5>Forget Password</h5>
                                            <span id="matchOtpModalBtn" data-toggle="modal" data-target="#matchOtpModal"></span>
                                            <button type="button" id="forgetClose" className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        
                                        {/* <!-- Modal body --> */}
                                        <div className="modal-body">
                                            <div className="px-4 py-1">
                                                <form onSubmit={this.forgetPassSubmit}>

                                                    <div className="form-group">
                                                        <label>Email <span className="text-danger">*</span></label>
                                                        <input onChange={this.handleChange} type="email" className="form-control" name="email" placeholder="Email" required></input>
                                                    </div>

                                                    <p className="text-danger"><b>Note: A password reset verification code will be sent to your email. Please submit that code to reset your password.</b></p>

                                                    <button type="submit" className="btn btn-md btn-info mt-3">Send Code</button>     
                                                </form>
                                            </div>                                                  
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="matchOtpModal">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                    
                                        {/* <!-- Modal Header --> */}
                                        <div className="modal-header">
                                            <h5>Submit Verification Code</h5>
                                            <span id="resetPassModalBtn" data-toggle="modal" data-target="#resetPassModal"></span>
                                            <button type="button" id="verificationClose" className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        
                                        {/* <!-- Modal body --> */}
                                        <div className="modal-body">
                                            <div className="px-4 py-1">
                                                <form onSubmit={this.VerificationCodeSubmit}>

                                                    <div className="form-group">
                                                        <label>Verification Code <span className="text-danger">*</span></label>
                                                        <input onChange={this.handleChange} type="text" className="form-control" name="otpcode" placeholder="Verification Code" required></input>
                                                    </div>

                                                    <button type="submit" className="btn btn-md btn-info mt-3">Submit</button>      
                                                </form>

                                                <button type="button" onClick={this.resendVerificationCode} className="btn btn-md btn-primary mt-3">Resend Verification Code</button>  
                                            </div>                                                  
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="resetPassModal">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                    
                                        {/* <!-- Modal Header --> */}
                                        <div className="modal-header">
                                            <h5>Reset Password</h5>
                                            <button type="button" id="resetClose" className="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        
                                        {/* <!-- Modal body --> */}
                                        <div className="modal-body">
                                            <div className="px-4 py-1">
                                                <form onSubmit={this.resetPassword}>

                                                    <div className="form-group">

                                                        <label>New Password <span className="text-danger">*</span></label>

                                                        <input onChange={this.handleChange} type="password" className="form-control" name="password" placeholder="Password" required></input>
                                                    </div>

                                                    <div className="form-group">

                                                        <label>Confirm New Password <span className="text-danger">*</span></label>

                                                        <input onChange={this.handleChange} type="password" className="form-control" name="confirm_password" placeholder="Confirm Password" required></input>
                                                    </div>

                                                    <button type="submit" className="btn btn-md btn-info mt-3">Submit</button>      
                                                </form>

                                            </div>                                                  
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div> 
                        
                </div>
            </div>
            }
            </>
        );
    }
}

export default BracBankRequiredLogin;